import Layout from '@components/layout';
import AuthLayout from '@components/layout/auth-layout';
import TokenGuard from '@components/layout/tokenGuard';
import { HomeRedirect } from '@components/guards/HomeRedirect';
import { routes, authRoutes } from '@router/index';
import { RootState } from '@utils/types';
import { Spinner } from 'flowbite-react';
import { Suspense } from 'react';
import { useSelector } from 'react-redux';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';

// Detect devstack URL prefix (/pr/<number> or /commit/<hash>) for React Router basename
function getBasename(): string {
  const match = window.location.pathname.match(/^\/(pr|commit)\/[^/]+/);
  return match ? match[0] : '/';
}
import 'react-toastify/dist/ReactToastify.css';
import 'react-datepicker/dist/react-datepicker.css';

function App() {
  const { loading } = useSelector((state: RootState) => state.common);
  return (
    <TokenGuard>
      <BrowserRouter basename={getBasename()}>
        <Suspense
          fallback={
            <div className="flex h-screen w-screen">
              <div className="m-auto">
                <Spinner color="info" />
              </div>
            </div>
          }
        >
          {loading && (
            <div className="absolute z-10 flex min-h-screen w-screen items-center justify-center bg-black/50">
              <Spinner color="info" />
            </div>
          )}
          <div className="min-h-screen w-screen overflow-x-hidden bg-primary-0">
            <Routes>
              {/* Home redirect — no layout wrapper to avoid header flash */}
              <Route path="/" element={<HomeRedirect />} />

              {/* Auth routes (login pages) with split-screen layout */}
              <Route element={<AuthLayout />}>
                {authRoutes.map((route) => (
                  <Route
                    path={route.path}
                    key={route.key}
                    element={route.element}
                  />
                ))}
              </Route>

              {/* Main routes with header layout */}
              <Route element={<Layout />}>
                {routes.map((route) => (
                  <Route
                    path={route.path}
                    key={route.key}
                    element={route.element}
                  />
                ))}
              </Route>
            </Routes>
          </div>
          <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar={true}
            newestOnTop={true}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="light"
          />
        </Suspense>
      </BrowserRouter>
    </TokenGuard>
  );
}

export default App;
